import GitOrganizationForm from './GitOrganizationForm';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';

export default withErrorBoundary(
  GitOrganizationForm,
  'Git Organization Selection'
);
